/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
/* eslint-disable max-len */

import axios from 'axios';
import { verifyIdToken } from 'providers/AuthProvider';

function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const HTTP_METHODS = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
});

function extend(obj, src) {
  for (const key in src) {
    if (src.hasOwnProperty(key)) obj[key] = src[key];
  }
  return obj;
}

function endpointTreatment(endpoint, options = {}) {
  let fullEndpoint = options.payment ? process.env.REACT_APP_API_PAYMENT_URL : process.env.REACT_APP_API_URL + endpoint;

  if (fullEndpoint[fullEndpoint.length - 1] !== '/' && !endpoint.includes('check-coupon')) {
    fullEndpoint = fullEndpoint.concat('/');
  }

  fullEndpoint = fullEndpoint.replace(/\/\//g, '/').replace(':/', '://');

  return fullEndpoint;
}

async function getToken() {
  try {
    const token = await verifyIdToken();
    return token;
  } catch (error) {
    // TODO: ERROR TREATMENT
    console.error(error);
  }
}

export default class HttpClient {
  static async getHeaders() {
    const headers = {
      'Content-Type': 'application/json',
      'mkt-cookies': getCookie('mkt_cookies'),
    };

    if (localStorage.session === 'true') {
      const id = await getToken();
      headers.Authorization = await `Bearer ${id}`;
    }

    return headers;
  }

  static catchError(error) {
    // TODO: ADD ERRORS TREATMENT
    throw error;
  }

  // TODO: ADD TREATMENT FOR OPTIONAL CONFIG AND HEADER VALUES
  static async request(method, endpoint, data = {}, options = {}) {
    const fullEndpoint = endpointTreatment(endpoint, options);
    const config = {
      method,
      url: fullEndpoint,
      headers: await this.getHeaders(options),
    };

    const args = await extend(data, config);

    // Log de requisições (development)
    if (process.env.NODE_ENV !== 'production') {
      console.log(`Calling ${method} at ${endpoint}.`);
    }

    return (
      axios(args)
        .then((response) => response)
        .catch(this.catchError)
    );
  }

  // METHOD GET
  static get(endpoint, options) {
    return this.request(HTTP_METHODS.GET, endpoint, {}, options);
  }

  // METHOD POST (DATA)
  static post(endpoint, data, options) {
    return this.request(HTTP_METHODS.POST, endpoint, { data }, options);
  }

  // METHOD PUT (DATA)
  static put(endpoint, data, options) {
    return this.request(HTTP_METHODS.PUT, endpoint, { data }, options);
  }

  // METHOD PATCH (DATA)
  static patch(endpoint, data, options) {
    return this.request(HTTP_METHODS.PATCH, endpoint, { data }, options);
  }

  // METHOD DELETE (DATA)
  static delete(endpoint, data, options) {
    return this.request(HTTP_METHODS.DELETE, endpoint, { data }, options);
  }
}
